<template>
  <div>
    <v-form ref="form" class="ma-10" v-model="validForm" autocomplete="chrome-off">
      <input autocomplete="chrome-off" name="hidden" type="text" style="display:none;">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-subheader>Date personale</v-subheader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-subheader style="justify-content: flex-end">Nume</v-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              rounded solo dense flat outlined single-line persistent-hint
              hint="Numele dumneavoastră"
              v-model="lastName"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-subheader style="justify-content: flex-end">Prenume</v-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              rounded solo dense flat outlined single-line persistent-hint
              hint="Prenumele dumneavoastră"
              v-model="firstName"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-subheader style="justify-content: flex-end">Email</v-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              rounded solo dense flat outlined single-line persistent-hint
              hint="Adresa de corespondenta. Nu afecteaza datele de autentificare."
              v-model="email"
              :rules="[rules.required, rules.email]">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-subheader style="justify-content: flex-end">Telefon</v-subheader>
          </v-col>
          <v-col cols="8">
            <v-text-field
              rounded solo dense flat outlined single-line persistent-hint
              hint="Numărul dumneavoastră de telefon."
              v-model="phone"
              :rules="[rules.required]">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn @click="toggleShowChangePass" text color="accent">
              Schimbare parola
              <v-icon right>
                {{ showChangePass ? 'mdi-eye-off': 'mdi-eye' }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <template v-if="showChangePass">
          <v-row>
            <v-col cols="4">
              <v-subheader style="justify-content: flex-end">Parola veche</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field
                clearable rounded solo dense flat outlined single-line persistent-hint
                hint="Daca doriti sa modificati parola va trebui sa introduceti parola curenta (pentru siguranta)."
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                v-model="passwordOld"
                :rules="[changePass]">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-subheader style="justify-content: flex-end">Parolă nouă</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field
                clearable rounded solo dense flat outlined single-line persistent-hint
                hint="Completati doar daca doriti sa modificati parola."
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                v-model="password"
                :rules="[rules.password, alike('passwordCheck'), oldPassIn]">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-subheader style="justify-content: flex-end">Verificare parolă nouă</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field
                clearable rounded solo dense flat outlined single-line persistent-hint
                hint="Completati doar daca doriti sa modificati parola. Valoarea acestui camp trebuie sa coincida cu valoarea campului anterior (parola noua)."
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                v-model="passwordCheck"
                :rules="[rules.password, alike('password'), oldPassIn]">
              </v-text-field>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col cols="12" justify="end">
            <v-row justify="end">
              <v-btn color="primary" @click="save" :disabled="loading || !validForm" :loading="loading">Salvează modificările</v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert :type="message.type" v-if="message" @input="alertChanged" dismissible>
              {{ message.text }}
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce'

export default {
  name: 'UserDetailsComponent',

  data: () => ({
    showChangePass: false,
    validForm: true,
    showPass: false,
    loading: false,
    message: null,
    firstName: null,
    lastName: null,
    email: null,
    password: null,
    passwordCheck: null,
    passwordOld: null,
    phone: null,
    rules: {
      required: val => !!val || 'Campul nu poate fi gol!',
      email: value => {
        /* eslint-disable no-useless-escape */
        const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
        return re.test(value) || 'Va rugam sa introduceti o adresa de email validă.'
      },
      password: value => {
        if (!value || !value.length) return true
        /* eslint-disable no-useless-escape */
        const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
        return re.test(value) || 'Campul trebuie sa fie de minim 8 caractere lungime si sa contina: litere mici, litere mari, cifre si caractere speciale (!, @, #, $, %, ^, &)!'
      }
    }
  }),

  computed: {
    user () {
      return this.$store.getters.user
    }
  },

  watch: {
    user: {
      immediate: true,
      handler (item) {
        if (item) {
          this.firstName = item.details?.firstName ?? item.firstName
          this.lastName = item.details?.lastName ?? item.lastName
          this.email = item.details?.email ?? item.email
          this.age = item.details?.age ?? null
          this.county = item.details?.county ?? null
          this.city = item.details?.city ?? null
          this.sex = item.details?.sex ?? null
          this.phone = item.details?.phone ?? null
        }
      }
    },

    password () {
      this.validateForm()
    },
    passwordCheck () {
      this.validateForm()
    },
    passwordOld () {
      this.validateForm()
    }
  },

  methods: {
    changePass () {
      return (this.password || this.passwordCheck) && (!this.passwordOld || !this.passwordOld.length) ? 'Trebuie sa introduceti parola veche pentru a schimba parola.' : true
    },
    oldPassIn () {
      if (this.password || this.passwordCheck) {
        if (!this.passwordOld) return 'Trebuie sa introduceti parola veche pentru a schimba parola.'
        return true
      }
      return true
    },
    async save () {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.loading = true
        try {
          const payload = {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone
          }

          if (this.password && this.passwordCheck && this.passwordOld) {
            payload.password = this.password.trim()
            payload.passwordCheck = this.passwordCheck.trim()
            payload.passwordOld = this.passwordOld.trim()
          }

          await this.$store.dispatch('saveUserDetails', payload)

          this.message = {
            type: 'success',
            text: 'Date salvate cu succes.'
          }
        } catch (err) {
          const codes = [
            'Parolele nu coincid.',
            'Trebuie sa introduceti parola veche pentru a autoriza noua parolă.',
            'Parola veche nu este cea corectă.'
          ]

          if (codes.includes(err.message)) {
            this.message = {
              type: 'error',
              text: err.message
            }
          } else {
            this.message = {
              type: 'error',
              text: 'Ne pare rau, am intampinat o eroare la salvarea datelor dumneavoastră.'
            }
          }
          console.log(err)
        } finally {
          this.loading = false
        }
      }
    },

    alike (ref) {
      return value => {
        const equal = (this[ref] === value) || ((!!this[ref] === !!value) && (!!value === false))

        return equal || 'Parolele trebuie să coincidă.'
      }
    },

    alertChanged ($event) {
      if (!$event) this.message = null
    },

    validateForm: _debounce(function () {
      this.$refs.form.validate()
    }, 500),

    toggleShowChangePass () {
      if (this.showChangePass) {
        this.password = null
        this.passwordCheck = null
        this.passwordOld = null
      }

      this.showChangePass = !this.showChangePass
    }
  }
}
</script>
